/**
 * Constants for Personal Identifying Information (PII) functionality
 */

// API Routes
export const PII_API_ROUTES = {
  SSN_READ: 'users/ssn/read',
  DOB_READ: 'users/dob/read',
  SSN_SET: 'users/set-ssn',
  SSN_SET_V2: 'v2/users/set-ssn',
  DOB_SET: 'users/set-date-of-birth',
};

//  API Request Data Keys
export const PII_API_DATA_KEYS = {
  USER_ID: 'userId',
  SSN_FULL_READ: 'ssnFullRead',
  LAST_FOUR: 'lastFour',
  SSN: 'ssn',
  DOB: 'dob',
};

// SSN Validation Constants
export const SSN_VALIDATION = {
  REQUIRED_LENGTH: 9,
  INVALID_PATTERNS: [
    /^000/, // Cannot start with 000
    /^666/, // Cannot start with 666
    /^9/, // Cannot start with 9
    /^(\d)\1{8}$/, // Cannot be all same digits
    /^123456789$/, // Sequential numbers
    /^987654321$/, // Reverse sequential numbers
    /^111111111$/, // All 1s
    /^222222222$/, // All 2s
    /^333333333$/, // All 3s
    /^444444444$/, // All 4s
    /^555555555$/, // All 5s
    /^777777777$/, // All 7s
    /^888888888$/, // All 8s
    /^000000000$/, // All 0s
  ],
};

// Date of Birth Validation Constants
export const DOB_VALIDATION = {
  MIN_DATE: '1900-01-01',
  // Function to get current date dynamically to avoid stale dates
  getMaxDate: () => new Date(),
};

// Error Message Keys
export const PII_ERROR_KEYS = {
  SSN_MUST_BE_9_DIGITS: 'pii.ssnMustBe9Digits',
  INVALID_SSN_FORMAT: 'pii.invalidSsnFormat',
  SSN_DOES_NOT_MATCH: 'pii.ssnDoesNotMatch',
  INVALID_DOB: 'pii.invalidDob',
  DOB_TOO_OLD: 'pii.dobTooOld',
  DOB_IN_FUTURE: 'pii.dobInFuture',
};

// Language Keys
export const PII_LANGUAGE_KEYS = {
  SSN: 'pii.ssn',
  EDIT: 'button.edit',
  VERIFY_SSN: 'pii.verifySsn',
  SAVE_SSN: 'pii.saveSsn',
  DATE_OF_BIRTH: 'pii.dateOfBirth',
  SAVE: 'buttonText.save',
};

// User Card PII Language Keys
export const USER_CARD_PII_LANGUAGE_KEYS = {
  USER_ID_REQUIRED: 'userCard.pii.userIdRequired',
  SSN_UPDATE_SUCCESS: 'userCard.pii.ssnUpdateSuccess',
  DOB_UPDATE_SUCCESS: 'userCard.pii.dobUpdateSuccess',
  SSN_FETCH_ERROR: 'userCard.pii.ssnFetchError',
  DOB_FETCH_ERROR: 'userCard.pii.dobFetchError',
};

// HTTP Methods
export const HTTP_METHODS = {
  POST: 'POST',
};
